import React from "react";
import PropTypes from "prop-types";
import "../css/cards.css";

const TopStudentsCard = ({ students }) => {
  const rows = Array.isArray(students) ? students.slice(0, 6) : [];

  if (!rows.length) {
    return (
      <div className="chart-card">
        <h3 className="chart-title">Top Movers</h3>
        <p className="chart-description">
          As soon as students start asking questions, their names will appear
          here with weekly totals.
        </p>
        <p className="dashboard-modal-empty compact">
          No active students have been logged this week.
        </p>
      </div>
    );
  }

  return (
    <div className="chart-card">
      <h3 className="chart-title">Top Movers</h3>
      <p className="chart-description">
        Weekly query count and follow-ups help you spot who’s pushing the pace
        in your course.
      </p>
      <div className="top-students-table">
        <table>
          <thead>
            <tr>
              <th>Student</th>
              <th>Weekly</th>
              <th>Follow-ups</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((student) => (
              <tr key={student.username || student.name}>
                <td>{student.name || student.username || "Student"}</td>
                <td>{student.weeklyQueries ?? 0}</td>
                <td>{student.followUps ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

TopStudentsCard.propTypes = {
  students: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      username: PropTypes.string,
      weeklyQueries: PropTypes.number,
      followUps: PropTypes.number,
    })
  ),
};

export default TopStudentsCard;
